import React, {useEffect} from 'react';
import './Accordion.scss'
import {connect} from "react-redux";
import AccordionItem from "./AccordionItem";

const Accordion = props => {
    const {items} = props;
    const accordionRef = React.createRef();
    const [activeIndex, setActiveIndex] = React.useState(-1);
    
    useEffect(() => {
        // Run when component mounts
        document.addEventListener("mousedown", handleClickOutsideAccordion);

        // Run when component unmounts
        return function cleanup() {
            document.removeEventListener("mousedown", handleClickOutsideAccordion);
        }
    })

    const handleClick = (index) => {
        // Determine which AccordionItem should be expanded by index
        setActiveIndex(prevIndex => prevIndex === index ? -1 : index)
    }

    const handleClickOutsideAccordion = (e) => {
        // Collapse any expanded AccordionItems
        if (!accordionRef.current?.contains(e.target)) {
            setActiveIndex(-1);
        }
    }

    if (items.length) {
        return (
            <div id="filterAccordion" ref={accordionRef} className="accordion">
                {items.map((item, index) => // Go over list of items and generate AccordionItems
                    <AccordionItem key={`accordion_item_${index}`} title={item.title}
                                   content={item.content} index={index} isActive={activeIndex === index}
                                   onClick={() => handleClick(index)}/>
                )}
            </div>
        );
    } else return null;
}

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps)(Accordion)